
//使用mockjs的模板生成随机数据
const data = {
    "code": 200,
    "data": [
        {
            "userName": "135****2438",
            "startTime": "19:51",
            "endTime": "20:03",
            "duration": 12,
            "startDate": "2023-05-25"
        },
        {
            "userName": "152****9845",
            "startTime": "19:51",
            "endTime": "20:07",
            "duration": 16,
            "startDate": "2023-05-25"
        },
        {
            "userName": "137****4585",
            "startTime": "17:44",
            "endTime": "17:54",
            "duration": 10,
            "startDate": "2023-05-25"
        },
        {
            "userName": "152****4528",
            "startTime": "17:05",
            "endTime": "17:25",
            "duration": 20,
            "startDate": "2023-05-25"
        },
        {
            "userName": "153****2082",
            "startTime": "16:51",
            "endTime": "17:11",
            "duration": 20,
            "startDate": "2023-05-25"
        },
        {
            "userName": "132****6142",
            "startTime": "13:35",
            "endTime": "13:45",
            "duration": 10,
            "startDate": "2023-05-25"
        },
        {
            "userName": "151****9704",
            "startTime": "13:27",
            "endTime": "13:52",
            "duration": 25,
            "startDate": "2023-05-25"
        },
        {
            "userName": "137****1071",
            "startTime": "09:50",
            "endTime": "10:08",
            "duration": 18,
            "startDate": "2023-05-25"
        },
        {
            "userName": "136****7764",
            "startTime": "23:18",
            "endTime": "23:30",
            "duration": 12,
            "startDate": "2023-05-24"
        },
        {
            "userName": "158****2711",
            "startTime": "17:36",
            "endTime": "17:46",
            "duration": 10,
            "startDate": "2023-05-24"
        },
        {
            "userName": "187****8380",
            "startTime": "16:30",
            "endTime": "16:40",
            "duration": 10,
            "startDate": "2023-05-24"
        },
        {
            "userName": "156****2700",
            "startTime": "16:13",
            "endTime": "16:33",
            "duration": 20,
            "startDate": "2023-05-24"
        },
        {
            "userName": "139****5715",
            "startTime": "19:59",
            "endTime": "20:29",
            "duration": 30,
            "startDate": "2023-05-23"
        },
        {
            "userName": "131****9844",
            "startTime": "18:03",
            "endTime": "18:13",
            "duration": 10,
            "startDate": "2023-05-23"
        },
        {
            "userName": "139****5611",
            "startTime": "15:28",
            "endTime": "15:48",
            "duration": 20,
            "startDate": "2023-05-23"
        },
        {
            "userName": "131****5732",
            "startTime": "23:33",
            "endTime": "23:43",
            "duration": 10,
            "startDate": "2023-05-22"
        },
        {
            "userName": "151****7947",
            "startTime": "22:05",
            "endTime": "22:25",
            "duration": 20,
            "startDate": "2023-05-22"
        },
        {
            "userName": "139****2015",
            "startTime": "21:05",
            "endTime": "21:15",
            "duration": 10,
            "startDate": "2023-05-22"
        },
        {
            "userName": "185****1583",
            "startTime": "19:24",
            "endTime": "19:44",
            "duration": 20,
            "startDate": "2023-05-22"
        },
        {
            "userName": "135****8573",
            "startTime": "19:21",
            "endTime": "19:36",
            "duration": 15,
            "startDate": "2023-05-22"
        }
    ],
    "message": "success"
}
export default data;

